import Vue from 'vue'
import Axios from 'axios'
import { io } from 'socket.io-client'
import Collection from './resource/types/collection'
import Index from './resource/types/index'
import Repository from './resource/repository'
import Requests from './requests'

const getWebsocket = (url, websocket) => {
  if (websocket) return websocket
  else {
    try {
      return io(url)
    } catch (e) {
      console.error(e)
      return null
    }
  }
}

const getAxios = (url, axios) => {
  if (axios) return axios
  else return Axios.create({
    baseURL: url,
  })
}

export default class Carrier {
  constructor (url, { axios, websocket } = {}) {
    this.url = url
    this.axios = getAxios(url, axios)

    this.indexes = {}
    this.collections = {}
    this.repository = Repository(this)
    this.requests = new Requests(this)

    this._vm = new Vue({
      data () {
        return {
          loading: 0,
        }
      }
    })

    if (websocket !== false) {
      this.applyWebsocket(websocket)
    }
  }

  applyWebsocket (websocket) {
    if (this.websocket) return
    this.websocket = getWebsocket(this.url, websocket)
    this.repository.subscribe()
  }

  /*
   * Resources
   */
  collection (options) {
    return new Collection(this, Math.random().toString(36).substr(2, 5), options)
  }

  index (path, options) {
    return Index(this, Math.random().toString(36).substr(2, 5), path, options)
  }

  /*
   * Low level REST Methods
   */
  get (path, params, options) {
    return this.request('get', this.sanitize(path), { ...options, params })
  }

  head (path, params, options) {
    return this.request('head', this.sanitize(path), { ...options, params })
  }

  delete (path, params, options) {
    return this.request('delete', this.sanitize(path), { ...options, params })
  }

  post (path, payload, options) {
    return this.request('post', this.sanitize(path), { ...options, payload })
  }

  put (path, params, options) {
    return this.request('put', this.sanitize(path), { ...options, payload })
  }

  patch (path, params, options) {
    return this.request('patch', this.sanitize(path), { ...options, payload })
  }

  /*
   * Helpers
   */
  request (method, path, options = {}) {
    return this.requests.push({
      method,
      path,
      options
    })
  }

  sanitize (path) {
    if (Array.isArray(path)) {
      return path.map(aPath => '/' + aPath.replace(new RegExp("^/+"), ''))
    } else if (typeof (path) === 'object') {
      return Object.fromEntries(Object.entries(path).map(([key, val]) => {
        return [key, '/' + val.replace(new RegExp("^/+"), '')]
      }))
    } else {
      return '/' + path.replace(new RegExp("^/+"), '')
    }
  }

  loading () {
    return this._vm.loading
  }

  /*
   * Event handling
   */
  on (...args) {
    return this._vm.$on.apply(this._vm, args)
  }

  off (...args) {
    return this._vm.$off.apply(this._vm, args)
  }

  once (...args) {
    return this._vm.$once.apply(this._vm, args)
  }

  emit (...args) {
    return this._vm.$emit.apply(this._vm, args)
  }
}